import { Text, VStack } from "@chakra-ui/react"
import { XState } from "container/xstate"
import React from "react"
import { MotionBox } from "../"
import { formatNumber } from "util/format"
import { PerpStakingLogo } from "component/Icon"
import { useToken } from "../../../../hook/useToken"
import { CONTRACT_ADDRESS } from "../../../../container/contract"

export function Balance() {
    const { state: current } = XState.useContainer()
    const { balance: stakingBalance } = useToken(CONTRACT_ADDRESS.STAKE_PERP_TOKEN, 18)

    return (
        <VStack spacing={0} h="74px" mt="64px" minHeight={74}>
            <MotionBox
                animate={{
                    scale: current.matches("connectWallet") ? 1.5 : 1,
                }}
            >
                <PerpStakingLogo />
            </MotionBox>
            <MotionBox
                initial={{ scale: 0, opacity: 0.5 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ delay: 1 }}
            >
                <Text lineHeight="57px" opacity={0.3} fontSize="48px" fontWeight="bold" color="#98989B">
                    {current.matches("connectWallet") ? "•_•" : formatNumber(stakingBalance.toFixed(1))}
                </Text>
            </MotionBox>
        </VStack>
    )
}
